import React, { useState } from "react";
import FormInput from "../../components/inputs/FormInput";
import Button from "../../components/button/Button";

const RequestDemoForm = () => {
  const [formData, setFormData] = useState({
    coachingName: "",
    state: "",
    city: "",
    name: "",
    mobile: "",
    email: "",
    time: "",
    message: "",
  });

  const states = ["Madhya Pradesh", "Uttar Pradesh", "Delhi", "Maharashtra"];
  const cities = ["Indore", "Bhopal", "Lucknow", "Mumbai"];
  const times = [
    "10:00 AM - 12:00 PM",
    "12:00 PM - 2:00 PM",
    "3:00 PM - 5:00 PM",
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data Submitted:", formData);
  };

  return (
    <div className="max-w-3xl mx-auto bg-white p-8 rounded-xl shadow-xl">
      <h2 className="text-xl font-semibold mb-6">Request A Demo</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <FormInput
          label="Coaching Name"
          name="coachingName"
          value={formData.coachingName}
          onChange={handleChange}
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* State Dropdown */}
          <div className="flex flex-col">
            <label className="text-sm text-defaultText mb-1">
              Select State <span className="text-red-500">*</span>
            </label>
            <select
              name="state"
              value={formData.state}
              onChange={handleChange}
              required
              className="w-full border-b border-[#8D8D8D] focus:outline-none bg-transparent"
            >
              <option value=""></option>
              {states.map((state) => (
                <option key={state}>{state}</option>
              ))}
            </select>
          </div>

          {/* City Dropdown */}
          <div className="flex flex-col">
            <label className="text-sm text-defaultText mb-1">Select City <span className="text-red-500">*</span></label>
            <select
              name="city"
              value={formData.city}
              onChange={handleChange}
              required
              className="w-full border-b border-[#8D8D8D] focus:outline-none bg-transparent"
            >
              <option value=""></option>
              {cities.map((city) => (
                <option key={city}>{city}</option>
              ))}
            </select>
          </div>

          <FormInput
            label="Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="col-span-1"
          />

          <FormInput
            label="Mobile Number"
            name="mobile"
            value={formData.mobile}
            onChange={handleChange}
            type="phone"
            className="col-span-1"
          />

          <FormInput
            label="Email ID"
            name="email"
            value={formData.email}
            onChange={handleChange}
            type="email"
            className="col-span-1"
          />

          {/* Time Dropdown */}
          <div className="flex flex-col">
            <label className="text-sm text-defaultText mb-1">
              Preferred Time <span className="text-red-500">*</span>
            </label>
            <select
              name="time"
              value={formData.time}
              onChange={handleChange}
              className="w-full border-b border-[#8D8D8D] focus:outline-none bg-transparent"
            >
              <option value=""></option>
              {times.map((time) => (
                <option key={time}>{time}</option>
              ))}
            </select>
          </div>
        </div>

        <FormInput
          label="Message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          type="textarea"
        />

        <div className="pt-4">
            <Button
            className="w-full"
            >
            BOOK A DEMO

            </Button>
          {/* <button
            type="submit"
            className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 rounded shadow"
          >
            BOOK A DEMO
          </button> */}
        </div>
      </form>
    </div>
  );
};

export default RequestDemoForm;
